var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3594FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_2147_1962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5401 16.8528C25.4745 16.8528 25.4187 16.8397 25.3728 16.8135C25.3269 16.7873 25.2908 16.7414 25.2645 16.6759L24.6938 15.339L23.2572 14.7099C23.1916 14.6837 23.1457 14.6477 23.1194 14.6018C23.0932 14.5559 23.0801 14.5002 23.0801 14.4347C23.0801 14.3692 23.0932 14.3135 23.1194 14.2676C23.1457 14.2217 23.1916 14.1857 23.2572 14.1595L24.6938 13.55L25.2645 12.2722C25.2908 12.2066 25.3269 12.1607 25.3728 12.1345C25.4187 12.1083 25.4745 12.0952 25.5401 12.0952C25.6057 12.0952 25.6614 12.1083 25.7073 12.1345C25.7533 12.1607 25.7893 12.2066 25.8156 12.2722L26.3863 13.55L27.8229 14.1595C27.8885 14.1857 27.9345 14.2217 27.9607 14.2676C27.9869 14.3135 28 14.3692 28 14.4347C28 14.5002 27.9869 14.5559 27.9607 14.6018C27.9345 14.6477 27.8885 14.6837 27.8229 14.7099L26.3863 15.339L25.8156 16.6759C25.7893 16.7414 25.7533 16.7873 25.7073 16.8135C25.6614 16.8397 25.6057 16.8528 25.5401 16.8528ZM25.5401 28.5699C25.4876 28.5699 25.4351 28.5568 25.3826 28.5306C25.3301 28.5044 25.2908 28.4585 25.2645 28.393L24.6938 27.1151L23.2769 26.5056C23.2113 26.4794 23.1653 26.4434 23.1391 26.3975C23.1129 26.3516 23.0997 26.2959 23.0997 26.2304C23.0997 26.1649 23.1129 26.1092 23.1391 26.0633C23.1653 26.0174 23.2113 25.9814 23.2769 25.9552L24.6938 25.3457L25.2645 23.9892C25.2908 23.9237 25.3269 23.8778 25.3728 23.8516C25.4187 23.8254 25.4745 23.8123 25.5401 23.8123C25.6057 23.8123 25.6614 23.8254 25.7073 23.8516C25.7533 23.8778 25.7893 23.9237 25.8156 23.9892L26.3863 25.3457L27.8033 25.9552C27.8689 25.9814 27.9148 26.0174 27.941 26.0633C27.9672 26.1092 27.9804 26.1649 27.9804 26.2304C27.9804 26.2959 27.9672 26.3516 27.941 26.3975C27.9148 26.4434 27.8689 26.4794 27.8033 26.5056L26.3863 27.1151L25.8156 28.393C25.7893 28.4585 25.75 28.5044 25.6975 28.5306C25.645 28.5568 25.5925 28.5699 25.5401 28.5699ZM16.9006 25.1688C16.7956 25.1688 16.6939 25.1393 16.5955 25.0803C16.4971 25.0214 16.4217 24.9394 16.3692 24.8346L15.09 22.1019L12.3348 20.8634C12.2298 20.8109 12.1478 20.7356 12.0888 20.6373C12.0298 20.539 12.0002 20.4374 12.0002 20.3326C12.0002 20.2277 12.0298 20.1261 12.0888 20.0278C12.1478 19.9295 12.2298 19.8542 12.3348 19.8018L15.09 18.5632L16.3692 15.8502C16.4217 15.7322 16.4971 15.6438 16.5955 15.5848C16.6939 15.5258 16.7956 15.4963 16.9006 15.4963C17.0055 15.4963 17.1072 15.5258 17.2056 15.5848C17.304 15.6438 17.3794 15.7257 17.4319 15.8305L18.7308 18.5632L21.4663 19.8018C21.5844 19.8542 21.6729 19.9295 21.732 20.0278C21.791 20.1261 21.8205 20.2277 21.8205 20.3326C21.8205 20.4374 21.791 20.539 21.732 20.6373C21.6729 20.7356 21.5844 20.8109 21.4663 20.8634L18.7308 22.1019L17.4319 24.8346C17.3794 24.9525 17.304 25.0377 17.2056 25.0902C17.1072 25.1426 17.0055 25.1688 16.9006 25.1688Z",
    fill: "url(#paint0_linear_2147_1962)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_2147_1962",
    x: 5.63348,
    y: 6.53344,
    width: 28.0015,
    height: 29.5741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.31726,
    dy: 2.48816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52475
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2147_1962"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.24408,
    dy: -1.1709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.19544
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2147_1962",
    result: "effect2_dropShadow_2147_1962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2147_1962",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9393
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2147_1962"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2147_1962",
    x1: 22.797,
    y1: 19.8499,
    x2: 20.3183,
    y2: 31.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAnswer);
export default __webpack_public_path__ + "static/media/aiAnswer.4b237771783ec92ae3cd5f445f512a89.svg";
export { ForwardRef as ReactComponent };